import { StreamActions } from "@hotwired/turbo"
import { coalescedReload } from "./coalesced_reload"

// MC-815 / ADR-20260701053432: a custom, content-less Turbo Stream action.
// The board broadcaster (Boards::ColumnBroadcast) sends
// `<turbo-stream action="refresh_frame" target="board-column-<id>">` on the
// shared `board:<space>` stream. Each client reloads only that column frame
// from its *own* `?parent=`-scoped `src`, so a filtered viewer re-renders
// through their own filter (per-viewer correctness) and the frame morphs in
// place (`refresh="morph"`). Frames not present in a given client's DOM (a
// different board sharing the stream, or an id that doesn't match) are a
// harmless no-op.
//
// MC-1733: the reload is single-flight with coalescing (coalescedReload) so
// the flood of broadcasts on a busy board does not turn into a flood of
// competing fetches. A refresh arriving while a frame is already reloading
// records one trailing reload instead of starting a second fetch or
// cancelling the first. This governs every `refresh_frame` target — board
// columns, the drawer timeline (Activities::TimelineBroadcast) and the
// attachments region (Tasks::AttachmentsBroadcast) — by the same discipline.
StreamActions.refresh_frame = function () {
  const frame = document.getElementById(this.getAttribute("target"))
  if (frame) coalescedReload(frame)
}
